var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SurveyTypesColumn.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Col } from '@sm/wds-react';
import './Submenu/nav-submenu.scss';
export var SurveyTypesColumn = function SurveyTypesColumn(_ref) {
  var children = _ref.children,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(Col, {
    className: "sm-nav-submenu__col",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "cardTitle",
    color: "dark",
    className: "sm-nav-submenu__column-title",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }, title), children);
};
export default SurveyTypesColumn;
SurveyTypesColumn.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
};
//# sourceMappingURL=SurveyTypesColumn.js.map